// extracted by mini-css-extract-plugin
export default {"modal":"Modal_modal__ZjBx1","modal-content":"Modal_modal-content__2X8PA","modal-header":"Modal_modal-header__A7zNT","modal-body":"Modal_modal-body__05hSR"};